/**
 * This is currently written like this because `gatsby-node.js` is
 * using this file and is running via NodeJS
 */
const localeFormatter = locale => {
  return locale.substring(0, 2)
}

module.exports = localeFormatter
